var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TedsLauncherLayout"},[_c('teds-launcher-top-bar'),_c('teds-launcher-icon-menu'),_c('teds-launcher-content',[_vm._t("default")],2),_c('teds-launcher-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }